export default {"src":"/_next/static/media/Content-6.7142463a.svg","height":292,"width":570};